import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

export default function CreateTeamAccounts() {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<any>(null);
  const { toast } = useToast();

  const handleCreateAccounts = async () => {
    setLoading(true);
    setResults(null);

    try {
      const { data, error } = await supabase.functions.invoke('create-team-accounts');

      if (error) throw error;

      setResults(data);
      
      toast({
        title: "Accounts Created",
        description: `Successfully created ${data.created} accounts with ${data.errors} errors`,
      });
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle>Create Team Accounts</CardTitle>
          <CardDescription>
            Create authentication accounts for all 12 iSPAI team members
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleCreateAccounts} 
            disabled={loading}
            className="w-full"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Creating Accounts...
              </>
            ) : (
              'Create All Team Accounts'
            )}
          </Button>

          {results && (
            <div className="mt-6 space-y-4">
              <div className="p-4 bg-muted rounded-lg">
                <h3 className="font-semibold mb-2">Summary</h3>
                <p>Created: {results.created} accounts</p>
                <p>Errors: {results.errors} errors</p>
              </div>

              {results.results && results.results.length > 0 && (
                <div className="space-y-2">
                  <h3 className="font-semibold">Successfully Created:</h3>
                  <div className="space-y-1 max-h-64 overflow-y-auto">
                    {results.results.map((result: any, index: number) => (
                      <div key={index} className="text-sm p-2 bg-green-50 rounded">
                        {result.display_name} - {result.email}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {results.errors && results.errors.length > 0 && (
                <div className="space-y-2">
                  <h3 className="font-semibold text-destructive">Errors:</h3>
                  <div className="space-y-1 max-h-64 overflow-y-auto">
                    {results.errors.map((error: any, index: number) => (
                      <div key={index} className="text-sm p-2 bg-red-50 rounded">
                        {error.email}: {error.error}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
